import React from "react";
import { TimerIcon } from "lucide-react";
import { useLoopingCountdown } from "../hooks/useLoopingCountdown";
type CountdownProps = {
  dark?: boolean;
};
export function Countdown({
  dark = false
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  return <div className="flex flex-col items-center" role="timer" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-35" data-mp="3c0b4hq4mtxtc">
      <p className={`mb-3 flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${dark ? "text-gold-light" : "text-navy"}`} data-id="element-36" data-mp="323q11989gurm">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-37" data-mp="373uf6slp5deo" />
        The special offer ends in:
      </p>
      <div className="flex items-start gap-2" data-id="element-38" data-mp="10dmxbi8g0b6f">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-39" data-mp="15boetyq802fs" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-40" data-mp="15an2lqxgx9wh">
              <span className={`flex h-16 w-16 items-center justify-center rounded-xl font-serif text-[2rem] font-bold tabular-nums sm:h-20 sm:w-20 sm:text-4xl ${dark ? "bg-gold text-navy" : "bg-navy text-gold-light"}`} data-id="element-41" data-mp="y0endtowvxxs">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${dark ? "text-white/70" : "text-navy/60"}`} data-id="element-42" data-mp="12son21ftwcd9">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-3 font-serif text-3xl font-bold sm:pt-5 ${dark ? "text-gold" : "text-navy"}`} data-id="element-43" data-mp="o2qu786yeyhq">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}